const WarningIcon = () => {
  return (
    <svg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='40' cy='40' r='40' fill='white' />
      <path
        d='M41.507 16C42.9873 16 44.3031 16.8224 45.0432 18.0559L64.9448 52.5137C66.2606 54.8163 64.6158 57.7769 61.902 57.7769H21.7699C19.056 57.7769 17.4113 54.8986 18.7271 52.5137L35.1747 17.3158L37.9708 16H41.507Z'
        fill='#C42D00'
      />
      <path
        d='M34.928 17.727L14.8619 52.4314C13.5461 54.7341 15.1909 57.6946 17.9047 57.6946H58.0369C60.7507 57.6946 62.3955 54.8163 61.0797 52.4314L41.0136 17.727C39.6978 15.4243 36.326 15.4243 34.928 17.727Z'
        fill='#FF5704'
      />
      <path d='M39.9445 44.9478H36.0793L35.2569 28.6646H40.7669L39.9445 44.9478Z' fill='white' />
      <path d='M39.9445 47.9906H36.0793V51.8557H39.9445V47.9906Z' fill='white' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80ZM40 79.2C61.6496 79.2 79.2 61.6496 79.2 40C79.2 18.3504 61.6496 0.8 40 0.8C18.3504 0.8 0.8 18.3504 0.8 40C0.8 61.6496 18.3504 79.2 40 79.2Z'
        fill='#E1E1E1'
      />
    </svg>
  );
};

export default WarningIcon;
